import { GameAction, GameActionTypes } from "./Game";
import { ApiError, Game } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { concatMap } from "rxjs";
import { ubisoftPYGActivate as apiUbisoftPYGActivate } from "@blacknut/javascript-sdk/dist/api/Ubisoft/ubisoftPYGActivate";
import { getGame as apiGetGame } from "@blacknut/javascript-sdk/dist/api/getGame";

const ubisoftPYGActivateRequest = (id: string): GameAction => ({
  type: GameActionTypes.UBISOFT_PYG_ACTIVATE_REQUEST,
  id,
});

const ubisoftPYGActivateSuccess = (game: Game): GameAction => ({
  type: GameActionTypes.UBISOFT_PYG_ACTIVATE_SUCCESS,
  game,
});
const ubisoftPYGActivateError = (id: string, e?: ApiError): GameAction => ({
  type: GameActionTypes.UBISOFT_PYG_ACTIVATE_ERROR,
  id,
  error: e,
});
export const dismissUbisoftPYGActivateError = (id: string) => {
  return (dispatch: Dispatch<GameAction>) => {
    dispatch(ubisoftPYGActivateError(id));
  };
};

export const ubisoftPYGActivate = (id: string) => {
  return (dispatch: Dispatch<GameAction>) => {
    return new Promise<void>((resolve, reject) => {
      dispatch(ubisoftPYGActivateRequest(id));
      apiUbisoftPYGActivate(id)
        .pipe(concatMap(() => apiGetGame(id)))
        .subscribe({
          next: (newGame) => {
            dispatch(ubisoftPYGActivateSuccess(newGame));
            resolve();
          },
          error: (error) => {
            dispatch(ubisoftPYGActivateError(id, error));
            reject(error);
          },
        });
    });
  };
};
